import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../axiosConfig';
import { useAuth } from '../authContext';

export default function Login() {
  const { fetchUser } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    console.log("test");
    e.preventDefault();
    console.log(form);
    // e.preventDefault();
    try {
        console.log(form);
      const res = await API.post('/auth/login', form);
      localStorage.setItem('access_token', res.data.access_token);
      localStorage.setItem('refresh_token', res.data.refresh_token);

      await fetchUser();        // Refresh user state in context
      navigate('/');            // Redirect to dashboard
    } catch (err) {
      setError('Invalid login');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="email"
        placeholder="Email"
        onChange={(e) => setForm({ ...form, email: e.target.value })}
        required
      />
      <input
        type="password"
        placeholder="Password"
        onChange={(e) => setForm({ ...form, password: e.target.value })}
        required
      />
      <button type="submit">Login</button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </form>
  );
}

// Login.js


// export default function Login({ onLogin }) {
//   const [form, setForm] = useState({ email: '', password: '' });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const res = await API.post('/login', form);
//     localStorage.setItem('token', res.data.access_token);
//     // onLogin();  // refresh protected UI
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <input placeholder="Email" onChange={e => setForm({...form, email: e.target.value})} />
//       <input type="password" placeholder="Password" onChange={e => setForm({...form, password: e.target.value})} />
//       <button>Login</button>
//     </form>
//   );
// }